// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"95":"e17f8d3de7a831c4158e","115":"b05219c2b99f34f49d97","767":"7ddd1801206eff9ae5f0"}[chunkId] + ".js";
};